import * as a1lib from "alt1/base";
import { observe } from "../reactive";
import { Process } from "../Process";
export class Alt1MouseTracking {
    constructor() {
        this.position = observe(null).structuralEquality();
    }
    startTracking() {
        const self = this;
        if (this.process)
            return;
        this.process = new class extends Process.Interval {
            constructor() { super(20); }
            tick() {
                if (self.position.changed.handlerCount() == 0) {
                    this.stop();
                    self.process = null;
                    return;
                }
                self.position.set(a1lib.getMousePosition());
            }
        };
        this.process.run();
    }
    subscribe(f) {
        const handler = this.position.subscribe2(pos => {
            if (pos)
                f(pos);
        });
        this.startTracking();
        return handler;
    }
}
